/**
 * Global Size Options Sync Manager
 * Synchronizes size selection between PDP main buttons and sticky add-to-cart dropdown.
 * Ensures the selected size is sent with AJAX add-to-cart requests.
 */

(function initGlobalSizeSync() {
  if (window.__customSizeSyncInitialized) return;
  window.__customSizeSyncInitialized = true;

  // Active size storage
  let currentSelectedSize = sessionStorage.getItem('selectedSize') || '';

  function updateAllSizePickers(selectedSize) {
    if (!selectedSize) return;
    currentSelectedSize = selectedSize;
    try {
      sessionStorage.setItem('selectedSize', selectedSize);
    } catch (e) {}

    // 1. Update PDP main size buttons
    const allButtons = document.querySelectorAll('.size-option-button');
    allButtons.forEach(btn => {
      const btnSize = btn.getAttribute('data-size-label') || btn.textContent.trim();
      const isMatch = btnSize.toLowerCase() === selectedSize.toLowerCase();
      if (isMatch) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
        btn.style.color = '#ffffff';
        btn.style.backgroundColor = '#000000';
        btn.style.borderColor = '#000000';
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
        btn.style.color = '#000000';
        btn.style.backgroundColor = '#ffffff';
        btn.style.borderColor = '#dddddd';
      }
    });

    // 2. Update sticky dropdown select
    const allSelects = document.querySelectorAll('.custom-size-select, [data-sticky-size-select]');
    allSelects.forEach(select => {
      if (select.value !== selectedSize) {
        // Find matching option
        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value.toLowerCase() === selectedSize.toLowerCase()) {
            select.selectedIndex = i;
            break;
          }
        }
      }
    });

    // 3. Update all hidden inputs for size properties
    const hiddenInputs = document.querySelectorAll('input[name="properties[Size]"], .custom-size-hidden-input, [id^="selected-size-input-"]');
    hiddenInputs.forEach(input => {
      input.value = selectedSize;
    });

    // 4. Update any forms with hidden property input
    const forms = document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    forms.forEach(form => {
      let propInput = form.querySelector('input[name="properties[Size]"]');
      if (!propInput) {
        propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = 'properties[Size]';
        form.appendChild(propInput);
      }
      propInput.value = selectedSize;
    });
  }

  // Change event delegation for dropdown select
  document.addEventListener('change', function(e) {
    const select = e.target.closest('.custom-size-select, [data-sticky-size-select]');
    if (!select) return;
    const selectedSize = select.value;
    if (selectedSize) {
      updateAllSizePickers(selectedSize);
    }
  });

  // Click delegation for PDP main size buttons
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.size-option-button');
    if (!btn) return;

    const selectedSize = btn.getAttribute('data-size-label') || btn.textContent.trim();
    if (selectedSize) {
      updateAllSizePickers(selectedSize);
    }
  });

  // Global window helper
  window.getSelectedSize = function() {
    return currentSelectedSize || sessionStorage.getItem('selectedSize') || '';
  };

  // Intercept fetch requests to /cart/add safely
  try {
    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      const patchedFetch = function(...args) {
        const url = args[0];
        const options = args[1] || {};

        if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
          const sizeToApply = window.getSelectedSize();
          if (sizeToApply) {
            if (options.body instanceof FormData) {
              if (!options.body.has('properties[Size]')) {
                options.body.append('properties[Size]', sizeToApply);
              } else {
                options.body.set('properties[Size]', sizeToApply);
              }
            } else if (typeof options.body === 'string') {
              try {
                const data = JSON.parse(options.body);
                if (Array.isArray(data.items)) {
                  data.items.forEach(item => {
                    if (!item.properties) item.properties = {};
                    item.properties.Size = sizeToApply;
                  });
                } else {
                  if (!data.properties) data.properties = {};
                  data.properties.Size = sizeToApply;
                }
                options.body = JSON.stringify(data);
              } catch (err) {
                // URLSearchParams fallback
                try {
                  const params = new URLSearchParams(options.body);
                  params.set('properties[Size]', sizeToApply);
                  options.body = params.toString();
                } catch (e) {}
              }
            }
            args[1] = options;
          }
        }
        return originalFetch.apply(this, args);
      };

      try {
        const desc = Object.getOwnPropertyDescriptor(window, 'fetch') || Object.getOwnPropertyDescriptor(Object.getPrototypeOf(window), 'fetch');
        if (desc) {
          if (desc.set || desc.writable) {
            window.fetch = patchedFetch;
          } else if (desc.configurable) {
            Object.defineProperty(window, 'fetch', {
              value: patchedFetch,
              writable: true,
              configurable: true,
              enumerable: true
            });
          }
        } else {
          window.fetch = patchedFetch;
        }
      } catch (e) {
        // Handled gracefully by form submission
      }
    }
  } catch (e) {}

  // Auto-select on DOM ready
  function autoSelectInitial() {
    const activeBtn = document.querySelector('.size-option-button.active');
    if (activeBtn) {
      const size = activeBtn.getAttribute('data-size-label') || activeBtn.textContent.trim();
      updateAllSizePickers(size);
    } else {
      const select = document.querySelector('.custom-size-select, [data-sticky-size-select]');
      if (select && select.value) {
        updateAllSizePickers(select.value);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSelectInitial);
  } else {
    autoSelectInitial();
  }
})();
